import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-icon_switch",
  "use": "icon-icon_switch-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-icon_switch\"><defs><style></style></defs><path d=\"M657.818 84.378a25.6 25.6 0 0 0-15.975 48.537 417.382 417.382 0 1 1-259.072 0 25.6 25.6 0 0 0-15.77-48.742 468.787 468.787 0 1 0 290.817 0z\" /><path d=\"M512 495.82a25.6 25.6 0 0 0 25.6-24.78V71.68a25.6 25.6 0 0 0-51.2 0v399.36a25.6 25.6 0 0 0 25.6 24.78z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol